/**
 * Content protection — deters casual snooping by blocking:
 *   - right-click context menu
 *   - F12 (DevTools)
 *   - Ctrl+Shift+I / J / C (DevTools + inspector)
 *   - Ctrl+U (View Source)
 *   - Ctrl+S (Save Page)
 *
 * NOTE: This is a deterrent, not real security. The JavaScript bundle is
 * still downloaded by the browser and can be inspected by anyone with basic
 * technical knowledge (network proxies, opening DevTools before the page
 * loads, etc.). Do not rely on this to protect secrets — always keep API
 * keys and business logic server-side.
 */

let installed = false;

const isBlockedKey = (e) => {
  // F12
  if (e.key === 'F12') return true;

  // Ctrl+U — View Source
  if ((e.ctrlKey || e.metaKey) && (e.key === 'u' || e.key === 'U')) return true;

  // Ctrl+S — Save Page
  if ((e.ctrlKey || e.metaKey) && (e.key === 's' || e.key === 'S')) return true;

  // Ctrl+Shift+I / J / C — DevTools
  if ((e.ctrlKey || e.metaKey) && e.shiftKey) {
    const k = (e.key || '').toLowerCase();
    if (k === 'i' || k === 'j' || k === 'c') return true;
  }

  return false;
};

const onContextMenu = (e) => {
  e.preventDefault();
  return false;
};

const onKeyDown = (e) => {
  if (isBlockedKey(e)) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }
  return true;
};

export const enableContentProtection = () => {
  if (installed) return;
  installed = true;
  document.addEventListener('contextmenu', onContextMenu, { capture: true });
  document.addEventListener('keydown', onKeyDown, { capture: true });
};

export const disableContentProtection = () => {
  if (!installed) return;
  installed = false;
  document.removeEventListener('contextmenu', onContextMenu, { capture: true });
  document.removeEventListener('keydown', onKeyDown, { capture: true });
};

export default { enableContentProtection, disableContentProtection };
